import React from 'react';
import classNames from 'classnames';
import s from './styles.module.scss';

export interface IAppTitleProps {
  title: string;
  subTitle?: string;
  main?: boolean;
  className?: string;
}

const AppTitle: React.FC<IAppTitleProps> = (props) => {
  const { title, subTitle, main = false, className = '' } = props;

  const titleClassNames = classNames(s['title'], className, {
    [s['margin']]: !!subTitle,
  });

  const subtitleClassNames = classNames(s['subtitle']);

  return (
    <>
      {main ? (
        <h1 className={titleClassNames} dir="auto">
          {title}
        </h1>
      ) : (
        <p className={titleClassNames} dir="auto">
          {title}
        </p>
      )}
      {subTitle && <p className={subtitleClassNames}>{subTitle}</p>}
    </>
  );
};

export default AppTitle;
